import { Link } from 'react-router';
import { useAuth } from '../auth/AuthProvider.js';
import { Avatar } from '../components/Avatar.js';
import { Badge } from '../components/Badge.js';
import { Button } from '../components/Button.js';
import { Header } from '../components/Header.js';
import { Layout } from '../components/Layout.js';
import { es } from '../i18n/es.js';
import { firstName } from '../lib/trip.js';

const sections = [
  { key: 'itinerary', ...es.home.sections.itinerary },
  { key: 'expenses', ...es.home.sections.expenses },
  { key: 'lodging', ...es.home.sections.lodging },
] as const;

export function HomePage() {
  const { user, signOut } = useAuth();
  if (!user) return null; // ProtectedRoute guarantees a user; keeps TS honest.

  const isAdmin = user.role === 'admin';

  return (
    <Layout>
      <Header
        actions={
          <>
            {isAdmin ? (
              <Link
                to="/admin"
                className="inline-flex min-h-11 items-center rounded-md px-3 text-sm font-medium text-accent hover:bg-accent-soft dark:hover:bg-accent/15"
              >
                {es.home.adminLink}
              </Link>
            ) : null}
            <Button variant="ghost" onClick={() => void signOut()}>
              {es.signOut}
            </Button>
          </>
        }
      />

      <section className="mt-6 flex items-center gap-4">
        <Avatar name={user.name} email={user.email} pictureUrl={user.pictureUrl} size="lg" />
        <div className="min-w-0">
          <h2 className="text-xl font-semibold tracking-tight">
            {es.home.greeting(firstName(user.name, user.email))}
          </h2>
          <p className="text-sm text-neutral-500 dark:text-neutral-400">{es.home.intro}</p>
        </div>
      </section>

      <section className="mt-8" aria-labelledby="coming-soon">
        <h2
          id="coming-soon"
          className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-500 dark:text-neutral-400"
        >
          {es.home.comingSoon}
        </h2>
        <ul role="list" className="mt-3 divide-y divide-neutral-200 dark:divide-neutral-800">
          {sections.map((s) => (
            <li key={s.key} className="flex items-start justify-between gap-4 py-4">
              <div className="min-w-0">
                <h3 className="font-medium">{s.title}</h3>
                <p className="mt-0.5 text-sm text-neutral-500 dark:text-neutral-400">
                  {s.description}
                </p>
              </div>
              <Badge tone="accent">{es.home.comingSoon}</Badge>
            </li>
          ))}
        </ul>
      </section>
    </Layout>
  );
}
